let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aUP5m")).then(() => parcelRequire('4TgXB'));